import { tokens } from "../theme";

export const mockDataTeam = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    access: "admin",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    access: "manager",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    access: "user",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    access: "admin",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    access: "user",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    access: "manager",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    access: "user",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    access: "user",
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    access: "admin",
  },
];

export const mockDataRecord = [
  {
    id: "sku-42245",    
    name: "Cephalexin",
    dosage: "M/A/E",
    instruction: "After Meal",
  },
  {
    id: "sku-72245",    
    name: "Amitriptyline",
    dosage: "M/A/E",
    instruction: "After Meal",    
  },
  {
    id: "sku-62245",    
    name: "Ibuprofen",
    dosage: "M/A/E",
    instruction: "After Meal",
    
  },
  
];


export const mockDataProducts = [
  {
    id: "sku-42245",    
    date:"24-04-2024",   
    name: "Cephalexin",
    stock: 12,
    price: "23",
  },
  {
    id: "sku-72245",    
    date:"24-04-2024",   
    name: "Amitriptyline",
    stock: 12,
    price: "2",     
  },
  {
    id: "sku-62245",    
    date:"24-04-2024",   
    name: "Ibuprofen",
    stock: 12,
    price: "12", 
    
  },
  {
    id: "sku-52245",    
    date:"24-04-2024",   
    name: "Entresto",
    stock: 10,
    price: "52", 
  },
  {
    id: "sku-32245",    
    date:"24-04-2024",   
    name: "Pantoprazole",
    stock: 34,
    price: "23", 
  },
  {
    id: "sku-425",    
    date:"24-04-2024",   
    name: "Meloxicam",
    stock: 2,
    price: "21", 
  }
];

export const mockPurchaseData = [
  {
    date:"24-04-2024",
    Medicine: "Cephalexin",
    id: 123512,
    vendor: "VK Medicals",
    orderTotal:"Rs 5345",
    status:"Delivered",
  },
  {
    date:"20-04-2024",
    Medicine: "Ibuprofen",
    id: 156321,    
    vendor: "Sahay edicals",
    orderTotal:"Rs 2345",
    status:"in Progress",
  },
  {
    date:"20-01-2024",
    Medicine: "Meloxicam",
    id: 123556,
    vendor: "Sahay edicals",
    orderTotal:"Rs 745",    
    status:"Open",
  },
];

export const mockDataContacts = [
  {
    id: 1,    
    date:"24-04-2024",
    Diagosis: "Bacterial Infection",
    Symtoms: "Stomach Ache",
    Medicine: "Cephalexin",
    InvoiceId: 123512,
    pathology: "Yes",
    report:"Here",
  },
  {
    id: 2,    
    date:"20-04-2024",
    Diagosis: "Viral",
    Symtoms: "Fever",
    Medicine: "Ibuprofen",
    InvoiceId: 123321,
    pathology: "No",
    report:"",
  },
  {
    id: 3,    
    date:"20-01-2024",
    Diagosis: "Flu",
    Symtoms: "Fever",
    Medicine: "Ibuprofen",
    InvoiceId: 123156,
    pathology: "No",
    report:"",
  },
  {
    id: 4,    
    date:"10-12-20243",
    Diagosis: "Flu",
    Symtoms: "Fever",
    Medicine: "Ibuprofen",
    InvoiceId: 122999,
    pathology: "No",
    report:"",
  },
  {
    id: 5,    
    date:"02-09-2023",
    Diagosis: "Flu",
    Symtoms: "Cold",
    Medicine: "Ibuprofen",
    InvoiceId: 122156,
    pathology: "No",
    report:"",
  },
  {
    id: 6,    
    date:"20-01-2023",
    Diagosis: "Flu",
    Symtoms: "Cough",
    Medicine: "Ibuprofen",
    InvoiceId: 122123,
    pathology: "No",
    report:"",
  }
];

export const mockDataInvoices = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    date: "03/12/2022",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    cost: "1.24",
    phone: "(421)314-2288",
    date: "06/15/2021",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    cost: "11.24",
    phone: "(422)982-6739",
    date: "05/02/2022",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    cost: "80.55",
    phone: "(921)425-6742",
    date: "03/21/2022",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    cost: "1.24",
    phone: "(421)445-1189",
    date: "01/12/2021",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    cost: "63.12",
    phone: "(232)545-6483",
    date: "11/02/2022",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    cost: "52.42",
    phone: "(543)124-0123",
    date: "02/11/2022",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    cost: "21.24",
    phone: "(222)444-5555",
    date: "05/02/2021",
  },
];

export const mockTransactions = [
  {  id: "01e4dsa",
     medicine: "Azithromycin",
     date: "2021-09-01",
     cost: "43.95",
     qty : "20",
  },
  {
    id: "0315dsaa",
    medicine: "Ciprofloxacin",
    date: "2022-04-01",
    cost: "133.45",
    qty : "21",
  },
  {
    id: "01e4dsa",    
    medicine: "Ibuprofen",
    date: "2021-09-01",
    cost: "43.95",
    qty : "15",
  },
  {
    id: "51034szv",
    medicine: "Narcan",
    date: "2022-11-05",
    cost: "200.95",
    qty : "10",
  },
  {
    id: "0a123sb",
    medicine: "Trazodone",
    date: "2022-11-02",
    cost: "13.55",
    qty : "20",
  },
  {
    id: "01e4dsa",
    medicine: "Lisinopril",
    date: "2021-09-01",
    cost: "43.95",
    qty : "2",
  },
  {
    id: "120s51a",
    medicine: "Doxycycline",
    date: "2019-04-15",
    cost: "24.20",
    qty : "11",
  },
  {
    id: "0315dsaa",
    medicine: "Acetaminophen",
    date: "2022-04-01",
    cost: "133.45",
    qty : "21",
  },
];

export const mockBarData = [
  {
    "country": "Homeo",
    "Expired": 137,
    "ExpiredColor": "hsl(229, 70%, 50%)",
    "Expiring soon": 96,
    "Expiring soonColor": "hsl(296, 70%, 50%)",
    "Expiring in 1 month": 72,
    "Expiring in 1 monthColor": "hsl(97, 70%, 50%)",
    "Good": 140,
    "GoodColor": "hsl(340, 70%, 50%)",
  },
  {
    "country": "Dental",
    "Expired": 17,
    "ExpiredColor": "hsl(229, 70%, 50%)",
    "Expiring soon": 96,
    "Expiring soonColor": "hsl(296, 70%, 50%)",
    "Expiring in 1 month": 72,
    "Expiring in 1 monthColor": "hsl(97, 70%, 50%)",
    "Good": 140,
    "GoodColor": "hsl(340, 70%, 50%)",
  },
  {
    "country": "Allopathy",
    "Expired": 197,
    "ExpiredColor": "hsl(229, 70%, 50%)",
    "Expiring soon": 96,
    "Expiring soonColor": "hsl(296, 70%, 50%)",
    "Expiring in 1 month": 72,
    "Expiring in 1 monthColor": "hsl(97, 70%, 50%)",
    "Good": 140,
    "GoodColor": "hsl(340, 70%, 50%)",
  },
  {
    country: "Gynae",
    "Expired": 137,
    "ExpiredColor": "hsl(229, 70%, 50%)",
    "Expiring soon": 96,
    "Expiring soonColor": "hsl(296, 70%, 50%)",
    "Expiring in 1 month": 72,
    "Expiring in 1 monthColor": "hsl(97, 70%, 50%)",
    "Good": 140,
    "GoodColor": "hsl(340, 70%, 50%)",
  },
  
];

export const mockPieData = [
  {
    id: "hack",
    label: "hack",
    value: 239,
    color: "hsl(104, 70%, 50%)",
  },
  {
    id: "make",
    label: "make",
    value: 170,
    color: "hsl(162, 70%, 50%)",
  },
  {
    id: "go",
    label: "go",
    value: 322,
    color: "hsl(291, 70%, 50%)",
  },
  {
    id: "lisp",
    label: "lisp",
    value: 503,
    color: "hsl(229, 70%, 50%)",
  },
  {
    id: "scala",
    label: "scala",
    value: 584,
    color: "hsl(344, 70%, 50%)",
  },
];

export const mockLineData = [
  {
    id: "homeopathy",
    color: tokens("dark").greenAccent[500],
    data: [
      {
        x: "Jan",
        y: 101,
      },
      {
        x: "Feb",
        y: 75,
      },
      {
        x: "Mar",
        y: 36,
      },
      {
        x: "Apr",
        y: 216,
      },
      {
        x: "May",
        y: 35,
      },
      {
        x: "Jun",
        y: 236,
      },
      {
        x: "Jul",
        y: 88,
      },
      {
        x: "Aug",
        y: 232,
      },
      {
        x: "Sep",
        y: 281,
      },
      {
        x: "Oct",
        y: 222,
      },
      {
        x: "Nov",
        y: 28,
      },
      {
        x: "Dec",
        y: 170,
      },
    ],
  },
  {
    id: "allopathy",
    color: tokens("dark").blueAccent[300],
    data: [
      {
        x: "Jan",
        y: 11,
      },
      {
        x: "Feb",
        y: 175,
      },
      {
        x: "Mar",
        y: 306,
      },
      {
        x: "Apr",
        y: 162,
      },
      {
        x: "May",
        y: 350,
      },
      {
        x: "Jun",
        y: 36,
      },
      {
        x: "Jul",
        y: 120,
      },
      {
        x: "Aug",
        y: 132,
      },
      {
        x: "Sep",
        y: 123,
      },
      {
        x: "Oct",
        y: 22,
      },
      {
        x: "Nov",
        y: 123,
      },
      {
        x: "Dec",
        y: 22,
      },
    ],
  },
  {
    id: "gynecology",
    color: tokens("dark").redAccent[200],
    data: [
      {
        x: "Jan",
        y: 101,
      },
      {
        x: "Feb",
        y: 75,
      },
      {
        x: "Mar",
        y: 36,
      },
      {
        x: "Apr",
        y: 216,
      },
      {
        x: "May",
        y: 35,
      },
      {
        x: "Jun",
        y: 236,
      },
      {
        x: "Jul",
        y: 82,
      },
      {
        x: "Aug",
        y: 26,
      },
      {
        x: "Sep",
        y: 28,
      },
      {
        x: "Oct",
        y: 170,
      },
      {
        x: "Nov",
        y: 28,
      },
      {
        x: "Dec",
        y: 170,
      },
    ],
  },
];

export const mockGeographyData = [
  {
    id: "AFG",
    value: 520600,
  },
  {
    id: "AGO",
    value: 949905,
  },
  {
    id: "ALB",
    value: 329910,
  },
  {
    id: "ARE",
    value: 675484,
  },
  {
    id: "ARG",
    value: 432239,
  },
  {
    id: "ARM",
    value: 288305,
  },
  {
    id: "ATA",
    value: 415648,
  },
  {
    id: "ATF",
    value: 665159,
  },
  {
    id: "AUT",
    value: 798526,
  },
  {
    id: "AZE",
    value: 481678,
  },
  {
    id: "BDI",
    value: 496457,
  },
  {
    id: "BEL",
    value: 252276,
  },
  {
    id: "BEN",
    value: 440315,
  },
  {
    id: "BFA",
    value: 343752,
  },
  {
    id: "BGD",
    value: 920203,
  },
  {
    id: "BGR",
    value: 261196,
  },
  {
    id: "BHS",
    value: 421551,
  },
  {
    id: "BIH",
    value: 974745,
  },
  {
    id: "BLR",
    value: 349288,
  },
  {
    id: "BLZ",
    value: 305983,
  },
  {
    id: "BOL",
    value: 430840,
  },
  {
    id: "BRN",
    value: 345666,
  },
  {
    id: "BTN",
    value: 649678,
  },
  {
    id: "BWA",
    value: 319392,
  },
  {
    id: "CAF",
    value: 722549,
  },
  {
    id: "CAN",
    value: 332843,
  },
  {
    id: "CHE",
    value: 122159,
  },
  {
    id: "CHL",
    value: 811736,
  },
  {
    id: "CHN",
    value: 593604,
  },
  {
    id: "CIV",
    value: 143219,
  },
  {
    id: "CMR",
    value: 630627,
  },
  {
    id: "COG",
    value: 498556,
  },
  {
    id: "COL",
    value: 660527,
  },
  {
    id: "CRI",
    value: 60262,
  },
  {
    id: "CUB",
    value: 177870,
  },
  {
    id: "-99",
    value: 463208,
  },
  {
    id: "CYP",
    value: 945909,
  },
  {
    id: "CZE",
    value: 500109,
  },
  {
    id: "DEU",
    value: 63345,
  },
  {
    id: "DJI",
    value: 634523,
  },
  {
    id: "DNK",
    value: 731068,
  },
  {
    id: "DOM",
    value: 262538,
  },
  {
    id: "DZA",
    value: 760695,
  },
  {
    id: "ECU",
    value: 301263,
  },
  {
    id: "EGY",
    value: 148475,
  },
  {
    id: "ERI",
    value: 939504,
  },
  {
    id: "ESP",
    value: 706050,
  },
  {
    id: "EST",
    value: 977015,
  },
  {
    id: "ETH",
    value: 461734,
  },
  {
    id: "FIN",
    value: 22800,
  },
  {
    id: "FJI",
    value: 18985,
  },
  {
    id: "FLK",
    value: 64986,
  },
  {
    id: "FRA",
    value: 447457,
  },
  {
    id: "GAB",
    value: 669675,
  },
  {
    id: "GBR",
    value: 757120,
  },
  {
    id: "GEO",
    value: 158702,
  },
  {
    id: "GHA",
    value: 893180,
  },
  {
    id: "GIN",
    value: 877288,
  },
  {
    id: "GMB",
    value: 724530,
  },
  {
    id: "GNB",
    value: 387753,
  },
  {
    id: "GNQ",
    value: 706118,
  },
  {
    id: "GRC",
    value: 377796,
  },
  {
    id: "GTM",
    value: 66890,
  },
  {
    id: "GUY",
    value: 719300,
  },
  {
    id: "HND",
    value: 739590,
  },
  {
    id: "HRV",
    value: 929467,
  },
  {
    id: "HTI",
    value: 538961,
  },
  {
    id: "HUN",
    value: 146095,
  },
  {
    id: "IDN",
    value: 490681,
  },
  {
    id: "IND",
    value: 549818,
  },
  {
    id: "IRL",
    value: 630163,
  },
  {
    id: "IRN",
    value: 596921,
  },
  {
    id: "IRQ",
    value: 767023,
  },
  {
    id: "ISL",
    value: 478682,
  },
  {
    id: "ISR",
    value: 963688,
  },
  {
    id: "ITA",
    value: 393089,
  },
  {
    id: "JAM",
    value: 83173,
  },
  {
    id: "JOR",
    value: 52005,
  },
  {
    id: "JPN",
    value: 199174,
  },
  {
    id: "KAZ",
    value: 181424,
  },
  {
    id: "KEN",
    value: 60946,
  },
  {
    id: "KGZ",
    value: 432478,
  },
  {
    id: "KHM",
    value: 254461,
  },
  {
    id: "OSA",
    value: 942447,
  },
  {
    id: "KWT",
    value: 414413,
  },
  {
    id: "LAO",
    value: 448339,
  },
  {
    id: "LBN",
    value: 620090,
  },
  {
    id: "LBR",
    value: 435950,
  },
  {
    id: "LBY",
    value: 75091,
  },
  {
    id: "LKA",
    value: 595124,
  },
  {
    id: "LSO",
    value: 483524,
  },
  {
    id: "LTU",
    value: 867357,
  },
  {
    id: "LUX",
    value: 689172,
  },
  {
    id: "LVA",
    value: 742980,
  },
  {
    id: "MAR",
    value: 236538,
  },
  {
    id: "MDA",
    value: 926836,
  },
  {
    id: "MDG",
    value: 840840,
  },
  {
    id: "MEX",
    value: 353910,
  },
  {
    id: "MKD",
    value: 505842,
  },
  {
    id: "MLI",
    value: 286082,
  },
  {
    id: "MMR",
    value: 915544,
  },
  {
    id: "MNE",
    value: 609500,
  },
  {
    id: "MNG",
    value: 410428,
  },
  {
    id: "MOZ",
    value: 32868,
  },
  {
    id: "MRT",
    value: 375671,
  },
  {
    id: "MWI",
    value: 591935,
  },
  {
    id: "MYS",
    value: 991644,
  },
  {
    id: "NAM",
    value: 701897,
  },
  {
    id: "NCL",
    value: 144098,
  },
  {
    id: "NER",
    value: 312944,
  },
  {
    id: "NGA",
    value: 862877,
  },
  {
    id: "NIC",
    value: 90831,
  },
  {
    id: "NLD",
    value: 281879,
  },
  {
    id: "NOR",
    value: 224537,
  },
  {
    id: "NPL",
    value: 322331,
  },
  {
    id: "NZL",
    value: 86615,
  },
  {
    id: "OMN",
    value: 707881,
  },
  {
    id: "PAK",
    value: 158577,
  },
  {
    id: "PAN",
    value: 738579,
  },
  {
    id: "PER",
    value: 248751,
  },
  {
    id: "PHL",
    value: 557292,
  },
  {
    id: "PNG",
    value: 516874,
  },
  {
    id: "POL",
    value: 682137,
  },
  {
    id: "PRI",
    value: 957399,
  },
  {
    id: "PRT",
    value: 846430,
  },
  {
    id: "PRY",
    value: 720555,
  },
  {
    id: "QAT",
    value: 478726,
  },
  {
    id: "ROU",
    value: 259318,
  },
  {
    id: "RUS",
    value: 268735,
  },
  {
    id: "RWA",
    value: 136781,
  },
  {
    id: "ESH",
    value: 151957,
  },
  {
    id: "SAU",
    value: 111821,
  },
  {
    id: "SDN",
    value: 927112,
  },
  {
    id: "SDS",
    value: 966473,
  },
  {
    id: "SEN",
    value: 158085,
  },
  {
    id: "SLB",
    value: 178389,
  },
  {
    id: "SLE",
    value: 528433,
  },
  {
    id: "SLV",
    value: 353467,
  },
  {
    id: "ABV",
    value: 251,
  },
  {
    id: "SOM",
    value: 445243,
  },
  {
    id: "SRB",
    value: 202402,
  },
  {
    id: "SUR",
    value: 972121,
  },
  {
    id: "SVK",
    value: 319923,
  },
  {
    id: "SVN",
    value: 728766,
  },
  {
    id: "SWZ",
    value: 379669,
  },
  {
    id: "SYR",
    value: 16221,
  },
  {
    id: "TCD",
    value: 101273,
  },
  {
    id: "TGO",
    value: 498411,
  },
  {
    id: "THA",
    value: 506906,
  },
  {
    id: "TJK",
    value: 613093,
  },
  {
    id: "TKM",
    value: 327016,
  },
  {
    id: "TLS",
    value: 607972,
  },
  {
    id: "TTO",
    value: 936365,
  },
  {
    id: "TUN",
    value: 898416,
  },
  {
    id: "TUR",
    value: 237783,
  },
  {
    id: "TWN",
    value: 878213,
  },
  {
    id: "TZA",
    value: 442174,
  },
  {
    id: "UGA",
    value: 720710,
  },
  {
    id: "UKR",
    value: 74172,
  },
  {
    id: "URY",
    value: 753177,
  },
  {
    id: "USA",
    value: 658725,
  },
  {
    id: "UZB",
    value: 550313,
  },
  {
    id: "VEN",
    value: 707492,
  },
  {
    id: "VNM",
    value: 538907,
  },
  {
    id: "VUT",
    value: 650646,
  },
  {
    id: "PSE",
    value: 476078,
  },
  {
    id: "YEM",
    value: 957751,
  },
  {
    id: "ZAF",
    value: 836949,
  },
  {
    id: "ZMB",
    value: 714503,
  },
  {
    id: "ZWE",
    value: 405217,
  },
  {
    id: "KOR",
    value: 171135,
  },
];

export const mockSearchData = [
  {
    "author": "Chinua Achebe",
    "country": "Nigeria",
    "imageLink": "images/things-fall-apart.jpg",
    "language": "English",
    "link": "https://en.wikipedia.org/wiki/Things_Fall_Apart\n",
    "pages": 209,
    "title": "Ram Kumar",
    "year": 1958
  },
  {
    "author": "Hans Christian Andersen",
    "country": "Denmark",
    "imageLink": "images/fairy-tales.jpg",
    "language": "Danish",
    "link": "https://en.wikipedia.org/wiki/Fairy_Tales_Told_for_Children._First_Collection.\n",
    "pages": 784,
    "title": "Prasad",
    "year": 1836
  },
  {
    "author": "Dante Alighieri",
    "country": "Italy",
    "imageLink": "images/the-divine-comedy.jpg",
    "language": "Italian",
    "link": "https://en.wikipedia.org/wiki/Divine_Comedy\n",
    "pages": 928,
    "title": "Devi Lal",
    "year": 1315
  },
  {
    "author": "Unknown",
    "country": "Sumer and Akkadian Empire",
    "imageLink": "images/the-epic-of-gilgamesh.jpg",
    "language": "Akkadian",
    "link": "https://en.wikipedia.org/wiki/Epic_of_Gilgamesh\n",
    "pages": 160,
    "title": "Savitri Devi",
    "year": -1700
  },
  {
    "author": "Unknown",
    "country": "Achaemenid Empire",
    "imageLink": "images/the-book-of-job.jpg",
    "language": "Hebrew",
    "link": "https://en.wikipedia.org/wiki/Book_of_Job\n",
    "pages": 176,
    "title": "Rampal Yadav",
    "year": -600
  },
  {
    "author": "Unknown",
    "country": "India/Iran/Iraq/Egypt/Tajikistan",
    "imageLink": "images/one-thousand-and-one-nights.jpg",
    "language": "Arabic",
    "link": "https://en.wikipedia.org/wiki/One_Thousand_and_One_Nights\n",
    "pages": 288,
    "title": "Raju Nigam",
    "year": 1200
  },
  
]